import React, { Component, Fragment  } from 'react';
import { NavLink } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
// import "react-multi-carousel/lib/styles.css";

class ItemCarousel extends Component {
	render() {
		const { sectionLabel, items, listType, mode } = this.props;
		const responsiveBreakpoints = {
			desktop: {
			  breakpoint: { max: 3000, min: 1024 },
			  items: 5,
			  slidesToSlide: 2,
			  partialVisibilityGutter: 40
			},
			tablet: {
			  breakpoint: { max: 1024, min: 464 },
			  items: 5,
			  slidesToSlide: 5,
			  partialVisibilityGutter: 40
			},
			mobile: {
			  breakpoint: { max: 464, min: 0 },
			  items: 5,
			  slidesToSlide: 3,
			  partialVisibilityGutter: 40
			},
		};

		if (items.length === 0) {
				return (
					<Fragment>
						<div className="grid-x grid-padding-x padding-bottom-2">
							<div className="cell">
								<h3 className="section-title mini artist padding-bottom-1">{ sectionLabel }</h3>
							</div>
						</div>

						<div className="grid-x grid-padding-x padding-bottom-2">
							<div className="cell"><p>Nothing to display</p></div>
						</div>
					</Fragment>
				);
			}

		return (
			<Fragment>
				<div className="grid-x">
					<div className="cell">
						<h3 className="section-title mini artist padding-bottom-1">{ sectionLabel }</h3>
					</div>
				</div>

				<Carousel 
					className="margin-bottom-3 admin-carousel"
					arrows={true}
					swipeable={true}
					draggable={true}
					infinite={items.length > 5}
					additionalTransfrom={items.length > 5 ? -15 : 10}
					responsive={responsiveBreakpoints}
					deviceType="desktop"
					partialVisible={false}
					itemClass="carouselement"
				>
					{
						items.map((item) => (
							<div key={ item._id } className="carousel-element cell shrink padding-top-1 padding-right-1 padding-bottom-1 text-center">
								<NavLink
									className="image medium"
									to={ `/artist/${item._id}/tracks` }
									style={
										{
											display: 'block',
											// backgroundImage: `url("${item.imagePath}")`,
											backgroundImage: `url("${
												(listType == "Artist" ? item.getArtistImage : 
													(listType == "Album" ? item.getAlbumArtwork : 
														"TODO: SONGS DONT HAVE IMAGES ATTACHED..."
													)
												)
											}")`,
											width: '10em',
											height: '10em',
											boxShadow: 'rgba(0, 0, 0, 0.8) 0px 0px 11px'
										}
									}>
								</NavLink>
								<p className="margin-top-1 carousel-label dark">{ (listType == ("Artist" || "Album") ? item.name : item.title) }</p>
							</div>
						))
					}
				</Carousel>
			</Fragment>
		);
	}
}

export default ItemCarousel;
